import React, { useState } from "react";
import SideBar from "../SideBar/sideBar";
import { useNavigate } from "react-router-dom";
import '../../index.css';
import LockIcon from '@mui/icons-material/Lock';
// Importing the PDF file you want to download
import opt_out_template from './opt_out_template.pdf';

const OptByMail = () => {
    const navigate = useNavigate();
    const FirstName = localStorage.getItem('firstName') || '';
    const LastName = localStorage.getItem('lastName') || '';
    const initials = `${FirstName.charAt(0)}${LastName.charAt(0)}`;
    const PlanTypeName = localStorage.getItem('PlanTypeName');

    const [loading, setLoading] = useState(false);

    return (
        <div className="flex h-100% bg-[#121212]">
            <SideBar />
            <main className="flex-1 overflow-y-auto p-6 min-h-screen">
            <div className="flex flex-col md:flex-row justify-between items-center mt-5 mb-4">
                    <h1 className="text-2xl md:text-3xl font-bold text-white">AI Remove Public Property Data</h1>
                    <div className="ml-0 md:ml-[30.75rem] mt-4 md:mt-0">
                        {PlanTypeName?.includes('Lifetime Access') && (
                            <h1 className="text-white font-semibold">You Have Lifetime Access</h1>
                        )}
                    </div>
                    <div className="w-10 h-10 bg-purple-500 rounded-full flex items-center justify-center mt-4 md:mt-0">
                        <span className="text-white font-bold">{initials}</span>
                    </div>
                </div>
                <div className="videoyou bg-[#1E1E1E] sm:p-4 rounded-lg mx-auto mb-8" style={{ height: "500px", maxWidth: "850px" }}>
                    <div className="relative h-full">
                        <iframe
                            width="100%"
                            height="100%"
                            src="https://player.vimeo.com/video/1021522086"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                            allowFullScreen
                            title="Video"
                            className="absolute inset-0 rounded-lg"
                        ></iframe>
                    </div>
                    {PlanTypeName === 'Free' ? (
                        <div className="centerbtn">
                            <button className="mt-8 px-6 py-3 bg-purple-600 text-white font-semibold rounded-lg hover:bg-purple-700 transition duration-300" onClick={() => navigate('/app/subscription')}>
                                Download Mail Template <LockIcon className='mr-2' />
                            </button>
                        </div>
                    ) : (
                        <div className="centerbtn">
                            <button
                                onClick={() => {
                                    const link = document.createElement('a');
                                    // Use the imported PDF file (opt_out_template) for the href
                                    link.href = opt_out_template;
                                    link.setAttribute('download', 'opt_out_template.pdf');
                                    document.body.appendChild(link);
                                    link.click();
                                    document.body.removeChild(link);
                                }}
                                className="mt-8 px-6 py-3 bg-purple-600 text-white font-semibold rounded-lg hover:bg-purple-700 transition duration-300"
                                disabled={loading}
                            >{loading ? 'Downloading...' : 'Download Mail Template'}
                            </button>
                        </div>
                    )}
                    <div className="mt-10">
                        <iframe style={{ width: '100%', height: '1000px' }} src="https://www.create.xyz/app/f7838251-375e-4180-9602-e1df1798b1af" title="Email To Core Logic " frameBorder="0"></iframe>
                    </div>
                </div>
            </main>
        </div>
    );
};

export default OptByMail;